import {Box, Button, HStack, Text} from '@chakra-ui/react';
import {colors} from 'components/providers';
import {IFilterType} from 'hooks';
import {useRouter} from 'next/router';
import {FC} from 'react';
import {TranslationKeys} from 'translations';

interface Props {
  t: (term: TranslationKeys) => string;
  activeQueryParams?: IFilterType;
  onChange: (filters: IFilterType) => void;
  sortingTypes: {
    name: {en: string; ru: string; ro: string};
    label: string;
  }[];
}

export const SortItems: FC<Props> = ({t, activeQueryParams, onChange, sortingTypes}) => {
  const {locale} = useRouter();
  const currentLang = locale as 'ru' | 'ro' | 'en';

  const handleChange = (ordering?: string) => {
    onChange({
      categorySlug: activeQueryParams?.categorySlug,
      ordering,
    });
  };
  return (
    <>
      <HStack w="100%" spacing="10px">
        <Text as="span" fontWeight="600" cursor="default">
          {t('SORT_BY')}:
        </Text>
        <HStack as="ul" listStyleType="none" spacing="5px">
          {sortingTypes.map((type) => {
            const isActive = activeQueryParams?.ordering === type.label;

            return (
              <Box as="li" key={type.label}>
                <Button
                  onClick={() => handleChange(type.label)}
                  variant="ghost"
                  px="10px"
                  sx={isActive ? {bg: colors.lightGray} : {}}
                  _focus={{border: 'none'}}
                  _hover={{
                    bg: colors.lightGray,
                  }}
                >
                  {type.name[currentLang]}
                </Button>
              </Box>
            );
          })}
        </HStack>
      </HStack>
    </>
  );
};
